angular.module('capability-ng-scheduler').factory('CourseBuilder', function CourseBuilder(Interface) {
  var DTD = {
    id: 'key',
    nk: 'string',
    cd: 'string',
    title: 'string', // looks the same as name
    desc: 'string',
    credits: 'number',
    term: 'key',
    terms: 'array',
    _sections: 'ngArray',
    _has_selected_section: 'boolean',
    _no_sections_available: 'boolean',
    _available_section_count: 'integer',
    _selected_section: 'object',
    _instructors: 'array',
    _checked: 'boolean',
    _required_sections: {
      type: 'ngArray',
      typeDef: 'RequiredSectionsBuilder'
    }
  };

  function CourseDTO(data) {
    Interface.implement(DTD, data, this);
  }

  return CourseDTO;
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/builders/suggestions/course_builder.es.js